document.addEventListener("DOMContentLoaded", function() {
  const slidesContainer = document.querySelector(".slides-container");
  const slides = document.querySelectorAll(".slide");
  const nextButton = document.querySelector(".nav-arrow.next");
  const prevButton = document.querySelector(".nav-arrow.prev");
  const navDotsContainer = document.querySelector(".banner-navigation"); // Dot container
  let currentIndex = 0;
  let autoSlideInterval;

function getCurrencyFrom3Letters(code) {
  const symbols = {
    AED: 'د.إ',
    AFN: '؋',
    ALL: 'L',
    AMD: '֏',
    ANG: 'ƒ',
    AOA: 'Kz',
    ARS: '$',
    AUD: 'A$',
    AWG: 'ƒ',
    AZN: '₼',
    BAM: 'KM',
    BBD: '$',
    BDT: '৳',
    BGN: 'лв',
    BHD: '.د.ب',
    BIF: 'FBu',
    BMD: '$',
    BND: '$',
    BOB: 'Bs.',
    BRL: 'R$',
    BSD: '$',
    BTN: 'Nu.',
    BWP: 'P',
    BYN: 'Br',
    BZD: '$',
    CAD: 'C$',
    CDF: 'FC',
    CHF: 'CHF',
    CLP: '$',
    CNY: '¥',
    COP: '$',
    CRC: '₡',
    CUP: '$',
    CVE: '$',
    CZK: 'Kč',
    DJF: 'Fdj',
    DKK: 'kr',
    DOP: '$',
    DZD: 'دج',
    EGP: '£',
    ERN: 'Nkf',
    ETB: 'Br',
    EUR: '€',
    FJD: '$',
    FKP: '£',
    FOK: 'kr',
    GBP: '£',
    GEL: '₾',
    GGP: '£',
    GHS: '₵',
    GIP: '£',
    GMD: 'D',
    GNF: 'FG',
    GTQ: 'Q',
    GYD: '$',
    HKD: 'HK$',
    HNL: 'L',
    HRK: '€',
    HTG: 'G',
    HUF: 'Ft',
    IDR: 'Rp',
    ILS: '₪',
    IMP: '£',
    INR: '₹',
    IQD: 'ع.د',
    IRR: '﷼',
    ISK: 'kr',
    JEP: '£',
    JMD: '$',
    JOD: 'د.ا',
    JPY: '¥',
    KES: 'KSh',
    KGS: 'лв',
    KHR: '៛',
    KID: '$',
    KMF: 'CF',
    KRW: '₩',
    KWD: 'د.ك',
    KYD: '$',
    KZT: '₸',
    LAK: '₭',
    LBP: 'ل.ل',
    LKR: 'Rs',
    LRD: '$',
    LSL: 'L',
    LYD: 'ل.د',
    MAD: 'د.م.',
    MDL: 'L',
    MGA: 'Ar',
    MKD: 'ден',
    MMK: 'K',
    MNT: '₮',
    MOP: 'P',
    MRU: 'UM',
    MUR: '₨',
    MVR: 'Rf',
    MWK: 'MK',
    MXN: '$',
    MYR: 'RM',
    MZN: 'MT',
    NAD: '$',
    NGN: '₦',
    NIO: 'C$',
    NOK: 'kr',
    NPR: '₨',
    NZD: 'NZ$',
    OMR: 'ر.ع.',
    PAB: 'B/.',
    PEN: 'S/',
    PGK: 'K',
    PHP: '₱',
    PKR: '₨',
    PLN: 'zł',
    PYG: '₲',
    QAR: 'ر.ق',
    RON: 'lei',
    RSD: 'дин',
    RUB: '₽',
    RWF: 'RF',
    SAR: '﷼',
    SBD: '$',
    SCR: '₨',
    SDG: 'ج.س.',
    SEK: 'kr',
    SGD: 'S$',
    SHP: '£',
    SLE: 'Le',
    SLL: 'Le',
    SOS: 'S',
    SRD: '$',
    SSP: '£',
    STN: 'Db',
    SYP: '£',
    SZL: 'E',
    THB: '฿',
    TJS: 'ЅМ',
    TMT: 'm',
    TND: 'د.ت',
    TOP: 'T$',
    TRY: '₺',
    TTD: '$',
    TVD: '$',
    TWD: 'NT$',
    TZS: 'Sh',
    UAH: '₴',
    UGX: 'USh',
    USD: '$',
    UYU: '$U',
    UZS: 'лв',
    VES: 'Bs.',
    VND: '₫',
    VUV: 'VT',
    WST: 'T',
    XAF: 'FCFA',
    XCD: '$',
    XOF: 'CFA',
    XPF: '₣',
    YER: '﷼',
    ZAR: 'R',
    ZMW: 'ZK',
    ZWL: '$'
  };

  return symbols[code] || '£'; // Default to GBP if not found
}


  // 🌍 Currency Configuration
  const CURRENCY = Shopify.currency?.active || 'GBP'; // Defaults to GBP if Shopify doesn't provide a currency
  const CURRENCY_SYMBOL = getCurrencyFrom3Letters(CURRENCY);    //const CURRENCY_SYMBOL = CURRENCY === 'GBP' ? '£' : '$'; // Adjust based on currency

  // 🔵 Create Navigation Dots (Ignoring Loader)
  navDotsContainer.innerHTML = ""; // Clear previous dots
  for (let i = 0; i < slides.length - 1; i++) { // Ignore first slide (loader)
    let dot = document.createElement("div");
    dot.classList.add("nav-btn");
    if (i === 0) dot.classList.add("active"); // Set first dot as active
    dot.dataset.index = i + 1; // Associate dot with slide (ignoring loader)
    navDotsContainer.appendChild(dot);
  }

  const navDots = document.querySelectorAll(".nav-btn"); // Re-query after creation

  function getSlideWidth() {
    const slideWidth = document.querySelector(".slide").offsetWidth;
    const slideMargin = 32; // 2em in pixels
    return slideWidth + slideMargin;
  }

  function updateSlide(skipAutoplay = false) {
    slidesContainer.style.transform = `translateX(-${currentIndex * getSlideWidth()}px)`;

    // Disable back button on "Slide 2" (index 1)
    prevButton.disabled = (currentIndex === 1);

    // Update nav dots (only considering slides **after** the loader)
    navDots.forEach((dot, index) => {
      dot.classList.toggle("active", index === currentIndex - 1);
    });

    // Reset autoplay when manually changed
    if (!skipAutoplay) {
      restartAutoplay();
    }
  }

  function nextSlide() {
    if (currentIndex < slides.length - 1) {
      currentIndex++;
    } else {
      currentIndex = 1; // 🔄 Loop back to first user-visible slide (skip loader)
    }
    updateSlide();
  }

  function prevSlide() {
    if (currentIndex > 1) { // Prevent going back to loader
      currentIndex--;
      updateSlide();
    }
  }

  function goToSlide(index) {
    currentIndex = index;
    updateSlide();
  }

  function restartAutoplay() {
    clearInterval(autoSlideInterval);
    autoSlideInterval = setInterval(nextSlide, 14000); // Auto-scroll every 14s
  }

  nextButton.addEventListener("click", nextSlide);
  prevButton.addEventListener("click", prevSlide);

  // 🔵 Allow dots to navigate slides
  navDots.forEach(dot => {
    dot.addEventListener("click", function() {
      const index = parseInt(this.dataset.index);
      goToSlide(index);
    });
  });

  // 🔄 Handle window resizing in real-time
  window.addEventListener("resize", updateSlide);

  // Initialize the first slide position
  updateSlide();

  // Fetch and populate product details
  const productHandle = document.querySelector(".product-info[data-product-handle]")?.getAttribute("data-product-handle");

  if (productHandle) {
    fetch(`/products/${productHandle}.js`)
      .then(response => {
        if (!response.ok) throw new Error("Product not found");
        return response.json();
      })
      .then(product => {
        const formattedPrice = Shopify.formatMoney 
          ? Shopify.formatMoney(product.price, `${CURRENCY_SYMBOL}{{amount}}`)  // Use Shopify format with dynamic symbol
          : `${CURRENCY_SYMBOL}${(product.price / 100).toFixed(2)}`;            // Fallback formatting

        document.querySelectorAll(".slide-price").forEach(el => el.textContent = formattedPrice);
        document.querySelectorAll(".product-name").forEach(el => el.textContent = product.title);
        document.querySelectorAll(".product-hyperlink").forEach(el => el.setAttribute("href", product.url));

        // ✅ Move to Slide 2 (Index 1) immediately after loading
        setTimeout(() => {
          currentIndex = 1; // Set to second slide
          updateSlide(true); // Skip autoplay reset
          restartAutoplay(); // Start auto-sliding
        }, 500); // Small delay to ensure content is rendered
      })
      .catch(error => console.error("Error fetching product price:", error));
  }
});
